import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, FormControl, FormGroup } from "react-bootstrap";
import { WIDGET_NAME } from "../../constants";
import SettingTabWrapper from "../../components/SettingTabWrapper";
import CommonSettings from "../SettingsTabs/CommonSettings";
import CommonStyles from "../SettingsTabs/CommonStyles";
import CardViewTile from "../SettingsTabs/CardViewTile";
import CardViewGrid from "../SettingsTabs/CardViewGrid";
import CardViewList from "../SettingsTabs/CardViewList";
import PopUpEpisode from "../SettingsTabs/PopUpEpisode";
import PopUpMemberProfile from "../SettingsTabs/PopUpMemberProfile";

const SettingsSidebar = ({
    eventPassword,
    eventSettings,
    isSaving,
    onSaveModel,
    onUpdateModel,
}) => {
    const history = useHistory();
    const [model, setModel] = useState(null);

    return (
        <FormGroup>
            <FormGroup style={{display: 'flex', columnGap: '12px'}}>
                <Button
                    bsStyle="primary"
                    disabled={isSaving}
                    onClick={onSaveModel}
                >
                    Сохранить
                </Button>
                <Button
                    disabled={isSaving}
                    onClick={() => history.push(`/event/${eventPassword}/widgets/program`)}
                >
                    Закрыть
                </Button>
            </FormGroup>
            {isSaving && (
                <p style={{fontStyle: 'italic', fontWeight: 'bold'}}>
                    Настройки успешно сохранены!
                </p>
            )}

            <FormGroup>
                <FormControl
                    type="text"
                    placeholder="Введите название виджета"
                    maxLength={50}
                    defaultValue={eventSettings?.[WIDGET_NAME] || ''}
                    onChange={(e) => setModel({...model, [WIDGET_NAME]: e.target.value})}
                    onBlur={(e) => onUpdateModel({[WIDGET_NAME]: e.target.value})}
                />
            </FormGroup>

            <FormGroup>
                <SettingTabWrapper
                    title="Общие настройки программы"
                    label="commonSettings"
                >
                    <CommonSettings
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Общие настройки цвета и текста"
                    label="commonStyles"
                >
                    <CommonStyles
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Вид карточки 'Плитка'"
                    label="cardViewTile"
                >
                    <CardViewTile
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Вид карточки 'Сетка'"
                    label="cardViewGrid"
                >
                    <CardViewGrid
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Вид карточки 'Список'"
                    label="cardViewList"
                >
                    <CardViewList
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Вид поп-ап 'Описание эпизода'"
                    label="popUpEpisode"
                >
                    <PopUpEpisode
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Вид поп-ап 'Профайл участника'"
                    label="popUpMemberProfile"
                >
                    <PopUpMemberProfile
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
            </FormGroup>
        </FormGroup>
    );
};

export default SettingsSidebar;
